




const swiper = new Swiper('.collection-slider', {  

  slidesPerView: 10,
  spaceBetween: 30,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 3.5,
      spaceBetween: 18
    },
    // when window width is >= 480px
    1000: {
      slidesPerView: 6,
      spaceBetween: 30
    },
    // when window width is >= 640px
    1290: {
      slidesPerView: 10,
      spaceBetween: 30
    }
  }
});

function initBundles(){
  const priceContainer = document.querySelector('.js-bundle-total-price')
  const bundleProdiuctsWraps =  document.querySelectorAll('.grid-product--bundle')
  const dataForAdding = document.querySelectorAll('.js-ajax-info')

  let price = 0

  if (!bundleProdiuctsWraps.length) {
    return
  }

  const overallDiscount = parseFloat(bundleProdiuctsWraps[0].querySelector('.js-ajax-info').getAttribute('data-bundle-discount'))

  bundleProdiuctsWraps.forEach(function(wrap){
    let thisPrice = parseFloat(wrap.querySelector('.js-ajax-info').getAttribute('data-price'))
    let discount = parseFloat(wrap.querySelector('.js-ajax-info').getAttribute('data-bundle-discount'))

    console.log(discount);
    console.log(price);
    price = price + (thisPrice - (thisPrice / 100 * discount))

  })

  priceContainer.innerHTML = "£" + (price/100).toFixed(2) + ` - including ${overallDiscount}% bundle saving`

  const addBtn = document.querySelector('.js-add-bundle')
  const url = `/cart/add.js`;

  addBtn.addEventListener('click', function(){

    addBtn.querySelector('.btn').classList.add('btn--loading')

    let data = []

    dataForAdding.forEach( (dataInfo) =>{
      let id = dataInfo.getAttribute('data-variant-id')
      let bundleTitle = dataInfo.getAttribute('data-bundle-title')
      let bundleDiscount = dataInfo.getAttribute('data-bundle-discount')
      data.push({id: id, quantity: 1,  properties: {
        'Type': 'Bundle Product',
        'Title': bundleTitle,
        'Discount': bundleDiscount
        }})
      
    })

    const payload = {"items" : data }    
  
  
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      handleResponse(data);
    })
    .catch((error) => {
      console.error(error); 
    });

    function handleResponse(data){
      console.log(data);
      console.log('updtaed with items!');   
      window.location.href = "/cart";
    }

  })


  //add to cart
}

function initBundlesRemove(){

    //remove from cart

    const removeBtns = document.querySelectorAll('.js-remove-bundle')
    const url = `/cart/update.js`;

    removeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()


        let idsToRemove = btn.getAttribute('data-ids-to-remove').split(",")

        let updates = {}

        idsToRemove.forEach((varid, index) => {

          if (!isNaN(parseInt( varid.trim())) ) {

            let id = parseInt( varid.trim())
            updates[id] = 0
          }
     
        })  
      


        const payload = {"updates" : updates }    


  
  
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        })
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          handleResponse(data);
        })
        .catch((error) => {
          console.log(error); 
        });
    
        function handleResponse(data){
          console.log(data);
          console.log('updtaed with items!');   
          window.location.href = "/cart";
        }
      })
    })
}


function initMegamenuDisableScroll(){
  const megamenuWrap = document.querySelectorAll('.site-nav__dropdown')
  const overlayTrigger = document.querySelectorAll('.site-nav__link')

  overlayTrigger.forEach((trigger) => {
    console.log(trigger);

    trigger.addEventListener('mouseenter', () => {
      console.log('entered fff');
      document.querySelector('.site-nav.site-navigation').classList.add('overlay')
    })

    trigger.addEventListener('mouseleave', () => {
      document.querySelector('.site-nav.site-navigation').classList.remove('overlay')
    })
  })




  megamenuWrap.forEach((menu) => {

    menu.addEventListener('mouseenter', () => {
      console.log('entered');

      document.querySelector('body').classList.add('disable-scroll')
      document.querySelector('.site-nav.site-navigation').classList.add('overlay')

      let wHeight = window.innerHeight

      let mHeight = menu.offsetHeight

      if ((mHeight ) > (wHeight - 267)) {
        console.log('too big!');
        menu.classList.add('too-big')
        
      }else{
        console.log('just right');
      }

    })

    menu.addEventListener('mouseleave', () => {
      console.log('exited');
      document.querySelector('body').classList.remove('disable-scroll');
      document.querySelector('.site-nav.site-navigation').classList.remove('overlay')

      megamenuWrap.forEach((menu) => {
        menu.scrollTop = 0
      })


    })
  })
}



initBundles()
initBundlesRemove()
initMegamenuDisableScroll()